import { SideBar } from '@components'
import { apiClient } from '@utils/api/client'
import { MENU } from '@utils/constants/menu'
import menu from '@utils/menu'
import { organization } from '@utils/store/organization.js'
import { site } from '@utils/store/site'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { matchRoutes, useLocation } from 'react-router'

/**
 * Sidebar manager component.
 *
 * @component
 * @returns {JSX.Element}
 */
export default function SideBarManager() {
  const namespaces = [
    { path: '/*', menu: MENU.HOME },
    { path: '/organizations', menu: MENU.HOME },
    { path: '/organizations/*', menu: MENU.ORGANIZATIONS },
    { path: '/organizations/:organization/sites/:site/*', menu: MENU.SITE },
    { path: '/configuration/*', menu: MENU.PARAMETERS }
  ]

  const siteStore = useSelector(site)
  const organizationStore = useSelector(organization)
  const [apiInfos, setApiInfos] = useState()
  const [loading, setLoading] = useState(true)
  const location = useLocation()
  const matches = matchRoutes(namespaces, location.pathname)
  const menuName = useMemo(() => matches?.[0]?.route.menu ?? null, [matches])
  const siteName = useMemo(() => siteStore.pretty_name ?? null, [siteStore])
  const mainTitle = useMemo(() => organizationStore.name ?? 'BeeBryte', [organizationStore])
  const logo = useMemo(() => organizationStore.logo ?? null, [organizationStore])
  const menuData = useMemo(
    () => menu(menuName, organizationStore.id, siteStore.id),
    [menuName, organizationStore.id, siteStore.id]
  )
  const logoUrl = useMemo(
    () => (organizationStore.id ? `/organizations/${organizationStore.id}/sites/` : '/'),
    [organizationStore]
  )
  const siteUrl = useMemo(
    () => (siteStore.id ? `/organizations/${organizationStore.id}/sites/${siteStore.id}` : '/'),
    [organizationStore, siteStore]
  )

  /**
   * Fetch API information from backend.
   *
   * @returns {Promise<void>}
   */
  const getAPIInfos = async () => {
    setLoading(true)
    await apiClient
      .get('/openapi.json')
      .then(({ data }) => {
        setApiInfos(data)
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    getAPIInfos()
  }, [])

  return (
    <SideBar
      className="main-sidebar"
      menu={menuData}
      currentUrl={location.pathname}
      logoUrl={logoUrl}
      siteUrl={siteUrl}
      mainTitle={mainTitle}
      siteName={siteName}
      logo={logo}
      apiInfos={apiInfos}
      coreInfos={{
        version: import.meta.env.APP_VERSION
      }}
      loadingApiInfos={loading}
    />
  )
}
